import { AudioManager } from '../systems/AudioManager';

export class AudioControls {
  private container: HTMLElement;
  private panel: HTMLElement;
  private isVisible: boolean = false;
  private audio: AudioManager;

  constructor(audio: AudioManager) {
    this.audio = audio;

    // 创建容器
    this.container = document.createElement('div');
    this.container.id = 'audio-controls-container';
    this.container.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 1000;
    `;

    // 创建音量按钮
    const button = document.createElement('button');
    button.id = 'audio-toggle-btn';
    button.innerHTML = '🔊';
    button.style.cssText = `
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.7);
      border: 2px solid #00ff00;
      color: white;
      font-size: 24px;
      cursor: pointer;
      transition: all 0.3s;
    `;

    button.addEventListener('mouseenter', () => {
      button.style.background = 'rgba(0, 255, 0, 0.3)';
      button.style.transform = 'scale(1.1)';
    });

    button.addEventListener('mouseleave', () => {
      button.style.background = 'rgba(0, 0, 0, 0.7)';
      button.style.transform = 'scale(1)';
    });

    button.addEventListener('click', () => {
      this.toggle();
    });

    // 创建音量面板
    this.panel = document.createElement('div');
    this.panel.id = 'audio-controls-panel';
    this.panel.style.cssText = `
      position: absolute;
      top: 60px;
      right: 0;
      width: 300px;
      background: rgba(0, 0, 0, 0.9);
      border: 2px solid #00ff00;
      border-radius: 10px;
      padding: 20px;
      display: none;
      box-shadow: 0 4px 20px rgba(0, 255, 0, 0.3);
    `;

    // 创建音量控制
    this.createVolumeSlider('主音量', 'master', this.audio.getMasterVolume());
    this.createVolumeSlider('音效', 'sfx', this.audio.getSfxVolume());
    this.createVolumeSlider('音乐', 'music', this.audio.getMusicVolume());

    // 创建说明
    const hint = document.createElement('div');
    hint.style.cssText = `
      margin-top: 15px;
      padding-top: 15px;
      border-top: 1px solid rgba(0, 255, 0, 0.3);
      font-size: 12px;
      color: #999;
      text-align: center;
    `;
    hint.textContent = '设置会自动保存';
    this.panel.appendChild(hint);

    // 组装
    this.container.appendChild(button);
    this.container.appendChild(this.panel);
    document.body.appendChild(this.container);
  }

  private createVolumeSlider(label: string, type: 'master' | 'sfx' | 'music', initialValue: number): void {
    const wrapper = document.createElement('div');
    wrapper.style.cssText = `
      margin-bottom: 15px;
    `;

    // 标签和值显示
    const labelRow = document.createElement('div');
    labelRow.style.cssText = `
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      color: white;
      font-size: 14px;
    `;

    const labelText = document.createElement('span');
    labelText.textContent = label;

    const valueText = document.createElement('span');
    valueText.id = `${type}-value`;
    valueText.textContent = `${Math.round(initialValue * 100)}%`;
    valueText.style.color = '#00ff00';

    labelRow.appendChild(labelText);
    labelRow.appendChild(valueText);

    // 滑块
    const slider = document.createElement('input');
    slider.type = 'range';
    slider.min = '0';
    slider.max = '100';
    slider.value = String(Math.round(initialValue * 100));
    slider.id = `${type}-slider`;
    slider.style.cssText = `
      width: 100%;
      height: 6px;
      border-radius: 3px;
      background: linear-gradient(to right, #00ff00 0%, #00ff00 ${initialValue * 100}%, #333 ${initialValue * 100}%, #333 100%);
      outline: none;
      cursor: pointer;
      -webkit-appearance: none;
    `;

    // 滑块样式
    const style = document.createElement('style');
    style.textContent = `
      #${type}-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #00ff00;
        cursor: pointer;
        box-shadow: 0 0 8px rgba(0, 255, 0, 0.6);
      }

      #${type}-slider::-moz-range-thumb {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #00ff00;
        cursor: pointer;
        border: none;
        box-shadow: 0 0 8px rgba(0, 255, 0, 0.6);
      }
    `;
    document.head.appendChild(style);

    // 滑块事件
    slider.addEventListener('input', (e) => {
      const value = parseInt((e.target as HTMLInputElement).value);
      const normalizedValue = value / 100;

      valueText.textContent = `${value}%`;

      // 更新背景渐变
      slider.style.background = `linear-gradient(to right, #00ff00 0%, #00ff00 ${value}%, #333 ${value}%, #333 100%)`;

      // 更新音量
      switch (type) {
        case 'master':
          this.audio.setMasterVolume(normalizedValue);
          break;
        case 'sfx':
          this.audio.setSfxVolume(normalizedValue);
          // 播放测试音效
          if (value > 0) {
            this.audio.playSound('ui_click', 0.5);
          }
          break;
        case 'music':
          this.audio.setMusicVolume(normalizedValue);
          break;
      }
    });

    wrapper.appendChild(labelRow);
    wrapper.appendChild(slider);
    this.panel.appendChild(wrapper);
  }

  toggle(): void {
    this.isVisible = !this.isVisible;
    this.panel.style.display = this.isVisible ? 'block' : 'none';
  }

  hide(): void {
    this.isVisible = false;
    this.panel.style.display = 'none';
  }

  show(): void {
    this.isVisible = true;
    this.panel.style.display = 'block';
  }
}
